import { render, staticRenderFns } from "./ButtonCategory.vue?vue&type=template&id=03a565aa&scoped=true&"
import script from "./ButtonCategory.vue?vue&type=script&lang=js&"
export * from "./ButtonCategory.vue?vue&type=script&lang=js&"
import style0 from "./ButtonCategory.vue?vue&type=style&index=0&id=03a565aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a565aa",
  null
  
)

export default component.exports